import styled from 'styled-components';

export const Container = styled.div`
    
`;

export const OrdersTitle = styled.h1`
    font-size: 40px;
    margin: 20px;
    font-weight: bold;
    color: #FFF;
`;

export const OrdersArea = styled.div`
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    flex-direction: row;
    padding: 40px;
    margin: 20px;
    border-radius: 10px;
    width: 100%;
    max-height: 95vh;
`;

export const Text = styled.p`
    font-size: 20px;
    font-weight: bold;
    color: #FFF;
`;